import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Card, CardBody, Row, Col, Form, Button, Modal } from "react-bootstrap";
import { Stack, Switch, Tooltip } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import Select from "react-select";
import DataTableLayout from "layouts/DatatableLayout";
import DatatableLayoutPagination from "layouts/DatatableLayoutPagination";
import DataSyncControl from "layouts/DataSyncControl";
import ShopAddressSelect, { shopAddressIds } from "layouts/ShopAddressSelect";
import { syncShop } from "../../redux/handlers/syncdata/syncShop.handler";
import { syncShopBranch } from "../../redux/handlers/syncdata/syncShopBranch.handler";
import { ModalAllder } from "layouts/ModalAllder";
import "react-datepicker/dist/react-datepicker.css";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import ImageIcon from "@mui/icons-material/Image";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import moment from "moment";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { getDataShop } from "../../redux/handlers/manage/getDataShop.handler";
import { getDataShopBranch } from "../../redux/handlers/manage/getDataShopBranch.handler";
import { getSaleuser } from "../../redux/handlers/manage/getSaleuser.handler";
import { getDataShopById } from "../../redux/handlers/manage/getDataShopById.handler";
import { getDataShopBranchById } from "../../redux/handlers/manage/getDataShopBranchById.handler";
import { createShop, clearcreateShop } from "../../redux/handlers/manage/createShop.handler";
import { updateShop, clearupdateShop } from "../../redux/handlers/manage/updateShop.handler";
import { updateStatusShop, clearupdateStatusShop } from "../../redux/handlers/manage/updateStatusShop.handler";
import { deleteShop, cleardeleteShop } from "../../redux/handlers/manage/deleteShop.handler";
import { uploadShop, clearuploadShop } from "../../redux/handlers/manage/uploadShop.handler";
import { updateStatusShBranch, clearupdateStatusShBranch } from "../../redux/handlers/manage/updateStatusShBranch.handler";
import { createShBranch, clearcreateShBranch } from "../../redux/handlers/manage/createShBranch.handler";
import { updateShBranch, clearupdateShBranch } from "../../redux/handlers/manage/updateShBranch.handler";
import { deleteShBranch, cleardeleteShBranch } from "../../redux/handlers/manage/deleteShBranch.handler";
import { getDiscountValue, NumberFormat, WDA, getPrefixName, filterTextAndNum, getInfoAdminSystem } from "utils/HelperFunction";
import { getShop } from "../../redux/handlers/manage/getShop.handler";
import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { http } from "utils/http";
import { endPoint } from "constants/server/api";
var BRANCH_GRADE_OPTIONS = [
    {
        value: 1,
        label: "Level 1"
    },
    {
        value: 2,
        label: "Level 2"
    },
    {
        value: 3,
        label: "Level 3"
    },
    {
        value: 4,
        label: "Level 4"
    }
];
var getBranchGradeLabel = function(grade) {
    var _BRANCH_GRADE_OPTIONS_find;
    return ((_BRANCH_GRADE_OPTIONS_find = BRANCH_GRADE_OPTIONS.find(function(option) {
        return option.value === Number(grade);
    })) === null || _BRANCH_GRADE_OPTIONS_find === void 0 ? void 0 : _BRANCH_GRADE_OPTIONS_find.label) || "-";
};
var VAT_CAL_OPTIONS = [
    {
        value: 1,
        label: "Ex VAT"
    },
    {
        value: 2,
        label: "In VAT"
    }
];
var getVatCalLabel = function(value) {
    var _VAT_CAL_OPTIONS_find;
    return ((_VAT_CAL_OPTIONS_find = VAT_CAL_OPTIONS.find(function(option) {
        return option.value === Number(value || 1);
    })) === null || _VAT_CAL_OPTIONS_find === void 0 ? void 0 : _VAT_CAL_OPTIONS_find.label) || "Ex VAT";
};
var useDebouncedValue = function(value) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 400;
    var _useState = _sliced_to_array(useState(value), 2), debouncedValue = _useState[0], setDebouncedValue = _useState[1];
    useEffect(function() {
        var timer = window.setTimeout(function() {
            return setDebouncedValue(value);
        }, delay);
        return function() {
            return window.clearTimeout(timer);
        };
    }, [
        delay,
        value
    ]);
    return debouncedValue;
};
// Enable synchronization actions for shops and branches.
var SHOW_SHOP_SYNC_BUTTONS = true;
export function Shop() {
    var accessToken = localStorage.getItem("accessToken");
    var adminInfo = getInfoAdminSystem(accessToken);
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    var _useState = _sliced_to_array(useState(""), 2), filterText = _useState[0], setFilterText = _useState[1];
    var debouncedFilterText = useDebouncedValue(filterText.trim());
    var _useState1 = _sliced_to_array(useState(0), 2), syncReloadKey = _useState1[0], setSyncReloadKey = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), modelText = _useState2[0], setmodelText = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), filteredItems = _useState3[0], setFilteredItems = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), rowData = _useState4[0], setRowData = _useState4[1];
    var _useState5 = _sliced_to_array(useState(false), 2), modalsuccess = _useState5[0], setModalsuccess = _useState5[1];
    var _useState6 = _sliced_to_array(useState(false), 2), textsuccess = _useState6[0], setTextsuccess = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), optionShop = _useState7[0], setOptionShop = _useState7[1];
    var _useState8 = _sliced_to_array(useState(""), 2), shopId = _useState8[0], setShopId = _useState8[1];
    var _useState9 = _sliced_to_array(useState(""), 2), shopTypeId = _useState9[0], setShopTypeId = _useState9[1];
    var isSaleRole = Number(adminInfo.userRoleId) === 3;
    var _useState10 = _sliced_to_array(useState(isSaleRole ? Number(adminInfo.userId) : ""), 2), saleId = _useState10[0], setSaleId = _useState10[1];
    var _useState11 = _sliced_to_array(useState([]), 2), optionSale = _useState11[0], setOptionSale = _useState11[1];
    var _useState12 = _sliced_to_array(useState(1), 2), pageId = _useState12[0], setPageId = _useState12[1];
    var _useState13 = _sliced_to_array(useState(10), 2), pageSize = _useState13[0], setPageSize = _useState13[1];
    var _useState14 = _sliced_to_array(useState([]), 2), sortModel = _useState14[0], setSortModel = _useState14[1];
    var _useState15 = _sliced_to_array(useState(false), 2), loading = _useState15[0], setLoading = _useState15[1];
    var _useState16 = _sliced_to_array(useState(0), 2), totalPage = _useState16[0], setTotalPage = _useState16[1];
    var _useState17 = _sliced_to_array(useState(0), 2), totalAmount = _useState17[0], setTotalAmount = _useState17[1];
    var optionShopType = [
        {
            value: 1,
            label: "RT"
        },
        {
            value: 2,
            label: "WT"
        },
        {
            value: 3,
            label: "MT"
        }
    ];
    var _useState18 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 0,
        width: !isMobile ? 500 : 300,
        height: 300,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modalDel = _useState18[0], setModalDel = _useState18[1];
    var _useState19 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 0,
        width: !isMobile ? 500 : 300,
        height: 300,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modalStatus = _useState19[0], setModalStatus = _useState19[1];
    var _useState20 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 0,
        width: !isMobile ? 560 : 320,
        height: !isMobile ? 340 : 420,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modalShop = _useState20[0], setModalShop = _useState20[1];
    var getDataShopReducer = useAppSelector(function(state) {
        return state.getDataShopReducer;
    });
    var getShopReducer = useAppSelector(function(state) {
        return state.getShopReducer;
    });
    var getSaleuserReducer = useAppSelector(function(state) {
        return state.getSaleuserReducer;
    });
    useEffect(function() {
        dispatch(getShop({}, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        dispatch(getSaleuser({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, []);
    useEffect(function() {
        var controller = new AbortController();
        var data = _object_spread(_object_spread_props(_object_spread({
            pageId: pageId,
            pageSize: pageSize
        }, shopId && {
            shopid: parseInt(shopId)
        }, shopTypeId && {
            typeshop: parseInt(shopTypeId)
        }, saleId && {
            saleid: parseInt(saleId)
        }), {
            searchtext: debouncedFilterText
        }), sortModel && {
            sortField: sortModel.sortField,
            sortValue: sortModel.sortValue
        });
        dispatch(getDataShop(data, {
            modalObj: modalObj,
            setModalObj: setModalObj,
            signal: controller.signal
        }));
        return function() {
            return controller.abort();
        };
    }, [
        pageId,
        pageSize,
        sortModel,
        debouncedFilterText,
        shopId,
        shopTypeId,
        saleId,
        syncReloadKey
    ]);
    var handleChangePage = function(newPage) {
        setPageId(newPage);
    };
    // // Handle Page Size Change
    var handleChangeRowsPerPage = function(newPageSize) {
        setPageSize(newPageSize);
    };
    useEffect(function() {
        setIsLoading(getDataShopReducer.isFetching || getShopReducer.isFetching);
        setLoading(getDataShopReducer.isFetching);
        if (getShopReducer.data) {
            var _getShopReducer_data;
            var allBranches = (getShopReducer === null || getShopReducer === void 0 ? void 0 : (_getShopReducer_data = getShopReducer.data) === null || _getShopReducer_data === void 0 ? void 0 : _getShopReducer_data.data) || [];
            var seenShopIds = new Set();
            var visibleBranches = isSaleRole ? allBranches.filter(function(branch) {
                return Number(branch.sh_branch_intendant) === Number(adminInfo.userId);
            }) : allBranches;
            var allShopOptions = visibleBranches.filter(function(branch) {
                var _branch_shShop;
                var shopId = branch === null || branch === void 0 ? void 0 : branch.sh_branch_shid;
                var shopName = branch === null || branch === void 0 ? void 0 : (_branch_shShop = branch.shShop) === null || _branch_shShop === void 0 ? void 0 : _branch_shShop.sh_shop_name;
                if (!shopId || !shopName || seenShopIds.has(shopId)) {
                    return false;
                }
                seenShopIds.add(shopId);
                return true;
            }).map(function(branch) {
                var _branch_shShop, _branch_shShop1;
                return {
                    value: branch.sh_branch_shid,
                    label: ((_branch_shShop = branch.shShop) === null || _branch_shShop === void 0 ? void 0 : _branch_shShop.sh_shop_code) ? "".concat(branch.shShop.sh_shop_name, " (").concat(branch.shShop.sh_shop_code, ")") : (_branch_shShop1 = branch.shShop) === null || _branch_shShop1 === void 0 ? void 0 : _branch_shShop1.sh_shop_name
                };
            });
            setOptionShop(allShopOptions);
        }
        if (getSaleuserReducer.data) {
            var saleOptions = (getSaleuserReducer.data.data || []).map(function(sale) {
                return {
                    value: sale.sys_user_id,
                    label: sale.sys_user_fullname
                };
            });
            setOptionSale(isSaleRole ? saleOptions.filter(function(sale) {
                return Number(sale.value) === Number(adminInfo.userId);
            }) : saleOptions);
        }
        if (getDataShopReducer.data && getShopReducer.data) {
            var _getDataShopReducer_data_data, _getDataShopReducer_data, _getDataShopReducer_data_data1, _getDataShopReducer_data1;
            var shops = (getDataShopReducer === null || getDataShopReducer === void 0 ? void 0 : (_getDataShopReducer_data = getDataShopReducer.data) === null || _getDataShopReducer_data === void 0 ? void 0 : (_getDataShopReducer_data_data = _getDataShopReducer_data.data) === null || _getDataShopReducer_data_data === void 0 ? void 0 : _getDataShopReducer_data_data.data) || [];
            var pagination = (getDataShopReducer === null || getDataShopReducer === void 0 ? void 0 : (_getDataShopReducer_data1 = getDataShopReducer.data) === null || _getDataShopReducer_data1 === void 0 ? void 0 : (_getDataShopReducer_data_data1 = _getDataShopReducer_data1.data) === null || _getDataShopReducer_data_data1 === void 0 ? void 0 : _getDataShopReducer_data_data1.pagination) || {};
            setFilteredItems(shops);
            setRowData(shops);
            setTotalPage((pagination === null || pagination === void 0 ? void 0 : pagination.totalPage) || 0);
            setTotalAmount((pagination === null || pagination === void 0 ? void 0 : pagination.total) || 0);
        }
    }, [
        getDataShopReducer,
        getShopReducer,
        getSaleuserReducer
    ]);
    useEffect(function() {
        var result = filteredItems;
        // filter ตาม text
        if (filterText) {
            var text = filterText.toLowerCase();
            result = result.filter(function(item) {
                return item.sh_shop_id !== null && (item.sh_shop_code != null && item.sh_shop_code.toUpperCase().includes(filterText.toUpperCase()) || item.sh_shop_name != null && item.sh_shop_name.includes(filterText));
            });
        }
        // // filter ตาม shopTypeId
        if (shopTypeId) {
            result = result.filter(function(item) {
                return item.sh_shop_typeshop === shopTypeId;
            });
        }
        // // filter ตาม shopId
        if (shopId) {
            result = result.filter(function(item) {
                return item.sh_shop_id === shopId;
            });
        }
        setRowData(result);
    }, [
        filterText,
        filteredItems,
        shopTypeId,
        shopId
    ]);
    var handleSort = function(column, sortDirection) {
        var field = column === null || column === void 0 ? void 0 : column.sortField;
        var value = sortDirection; // 'asc' หรือ 'desc'
        console.log("Sort:", {
            sortField: field,
            sortValue: value
        });
        setSortModel({
            sortField: field,
            sortValue: value
        });
    };
    var columns = [
        {
            name: "จัดการ",
            width: "190px",
            selector: function(row) {
                return row.sh_shop_id;
            },
            // center: "true",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex align-items-center gap-1",
                    children: [
                        /*#__PURE__*/ _jsx(Link, {
                            to: "/shop/manage/".concat(row.sh_shop_id),
                            style: {
                                marginRight: 5
                            },
                            children: /*#__PURE__*/ _jsx(Tooltip, {
                                title: "จัดการรายการร้านค้า",
                                children: /*#__PURE__*/ _jsx(MenuBookIcon, {
                                    style: {
                                        color: "#0284feff",
                                        fontSize: 30,
                                        borderRadius: 40,
                                        background: "#0284fe1a",
                                        padding: 5
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx(Link, {
                            onClick: function() {
                                setModalShop(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true,
                                        data: {
                                            id: row === null || row === void 0 ? void 0 : row.sh_shop_id,
                                            name: row === null || row === void 0 ? void 0 : row.sh_shop_name,
                                            typrShop: row === null || row === void 0 ? void 0 : row.sh_shop_typeshop
                                        }
                                    });
                                });
                                setmodelText("แก้ไขร้านค้า");
                            },
                            style: {
                                marginRight: 5
                            },
                            children: /*#__PURE__*/ _jsx(Tooltip, {
                                title: "แก้ไขร้านค้า",
                                children: /*#__PURE__*/ _jsx(EditIcon, {
                                    style: {
                                        color: "#797A7A",
                                        fontSize: 30,
                                        borderRadius: 40,
                                        background: "#E9E9E9",
                                        padding: 5
                                    }
                                })
                            })
                        }),
                        row.sh_shop_can_delete === false ? "" : /*#__PURE__*/ _jsx(Link, {
                            onClick: function() {
                                setModalDel(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true,
                                        typeData: "shShopDel",
                                        data: {
                                            id: row.sh_shop_id,
                                            name: row.sh_shop_name
                                        }
                                    });
                                });
                                setmodelText("ยืนยันลบร้านค้า");
                            },
                            style: {
                                marginRight: 3
                            },
                            children: /*#__PURE__*/ _jsx(Tooltip, {
                                title: "ยืนยันลบร้านค้า",
                                children: /*#__PURE__*/ _jsx(DeleteOutline, {
                                    style: {
                                        fontSize: 30,
                                        borderRadius: 40,
                                        background: "rgb(255, 227, 227)",
                                        color: "#FF0000",
                                        padding: 5
                                    }
                                })
                            })
                        }),
                        SHOW_SHOP_SYNC_BUTTONS && /*#__PURE__*/ _jsx(DataSyncControl, {
                            syncStatus: row.sh_shop_syncstatus,
                            rowData: row,
                            syncHandler: syncShop,
                            syncPayload: function(data) {
                                return {
                                    shopid: data.sh_shop_id,
                                    postal_code: "",
                                    country: "",
                                    country_code: ""
                                };
                            },
                            syncHandlerOptions: {
                                modalObj: modalObj,
                                setModalObj: setModalObj
                            },
                            onSyncSuccess: function() {
                                return setSyncReloadKey(function(value) {
                                    return value + 1;
                                });
                            }
                        })
                    ]
                });
            }
        },
        {
            name: "รหัส",
            selector: function(row) {
                return row.sh_shop_code;
            },
            center: "true",
            sortable: true,
            sortField: "sh_shop_code"
        },
        {
            name: "ชื่อร้านค้า",
            selector: function(row) {
                return row.sh_shop_name;
            },
            sortable: true,
            sortField: "sh_shop_name"
        },
        {
            name: "จำนวนสาขา",
            width: "140px",
            selector: function(row) {
                return row === null || row === void 0 ? void 0 : row._count;
            },
            center: "true",
            sortable: true,
            sortField: "shBranch",
            cell: function(row, index, column, id) {
                var _row__count;
                return (row === null || row === void 0 ? void 0 : (_row__count = row._count) === null || _row__count === void 0 ? void 0 : _row__count.shBranch) || 0;
            }
        },
        {
            name: "ประเภทร้านค้า",
            selector: function(row) {
                return row === null || row === void 0 ? void 0 : row.sh_shop_typeshop;
            },
            center: "true",
            sortable: true,
            sortField: "sh_shop_typeshop",
            cell: function(row, index, column, id) {
                return (row === null || row === void 0 ? void 0 : row.sh_shop_typeshop) == 0 && "-" || (row === null || row === void 0 ? void 0 : row.sh_shop_typeshop) == 1 && "RT" || (row === null || row === void 0 ? void 0 : row.sh_shop_typeshop) == 2 && "WT" || (row === null || row === void 0 ? void 0 : row.sh_shop_typeshop) == 3 && "MT";
            }
        },
        {
            name: "วันที่สร้าง",
            selector: function(row) {
                return row.sh_shop_credate ? moment.parseZone(row.sh_shop_credate).format("DD/MM/YYYY HH:mm") : "-";
            },
            center: "true",
            width: "170px",
            sortable: true,
            sortField: "sh_shop_credate"
        },
        {
            name: "สถานะการใช้งาน",
            selector: function(row) {
                return row.sh_shop_status;
            },
            center: "true",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx(Switch, {
                    checked: row.sh_shop_status == 1,
                    onClick: function() {
                        setModalStatus(function(prev) {
                            return _object_spread_props(_object_spread({}, prev), {
                                open: true,
                                typeData: "shShopStatus",
                                data: {
                                    id: row.sh_shop_id,
                                    name: row.sh_shop_name,
                                    status: row.sh_shop_status
                                }
                            });
                        });
                    }
                });
            }
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: !isMobile ? "pagezoom" : "",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: !isMobile ? "breadcrumb fs-16 ps-0 mb-1" : "breadcrumb fs-14 ps-2 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "/shop",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการร้านค้า"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: !isMobile ? "fs-24 mb-2" : "fs-20 mb-2 ps-2",
                        children: "จัดการร้านค้า"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsxs(Card, {
                    children: [
                        /*#__PURE__*/ _jsx(CardBody, {
                            children: /*#__PURE__*/ _jsxs(Row, {
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 2,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 p-0",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1 z-3",
                                                    children: "ค้นหาร้านค้า"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, {
                                                    className: "w-100 select-st-3 z-2",
                                                    placeholder: "ค้นหาร้านค้า",
                                                    options: optionShop,
                                                    value: optionShop.find(function(opt) {
                                                        return opt.value === shopId;
                                                    }) || "",
                                                    onChange: function(e) {
                                                        setShopId(e ? e.value : "");
                                                        setPageId(1);
                                                    },
                                                    isClearable: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 2,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 p-0",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1 z-3",
                                                    children: "ค้นหาประเภทร้านค้า"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, {
                                                    className: "w-100 select-st-3 z-2",
                                                    placeholder: "ค้นหาประเภทร้านค้า",
                                                    options: optionShopType,
                                                    value: optionShopType.find(function(opt) {
                                                        return opt.value === shopTypeId;
                                                    }) || "",
                                                    onChange: function(e) {
                                                        setShopTypeId(e ? e.value : "");
                                                        setPageId(1);
                                                    },
                                                    isClearable: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 2,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 p-0",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1 z-3",
                                                    children: "เซลล์ผู้ดูแล"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, {
                                                    className: "w-100 select-st-3 z-2",
                                                    placeholder: "เลือกเซลล์ผู้ดูแล",
                                                    options: optionSale,
                                                    value: optionSale.find(function(opt) {
                                                        return Number(opt.value) === Number(saleId);
                                                    }) || "",
                                                    onChange: function(e) {
                                                        setSaleId(e ? e.value : "");
                                                        setPageId(1);
                                                    },
                                                    isClearable: !isSaleRole,
                                                    isDisabled: isSaleRole
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 0,
                                        md: 0,
                                        lg: 1
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 12,
                                        lg: 3,
                                        children: /*#__PURE__*/ _jsx("input", {
                                            type: "text",
                                            className: "form-control mt-[15px]",
                                            placeholder: "ค้นหารายการ",
                                            value: filterText,
                                            onChange: function(e) {
                                                setFilterText(e.target.value);
                                                setPageId(1);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 12,
                                        lg: 2,
                                        children: /*#__PURE__*/ _jsx(Link, {
                                            className: "btn btn-dg w-[100%] mt-[15px]",
                                            to: "/shop/manage",
                                            children: "สร้างร้านค้า"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(DatatableLayoutPagination, {
                            item: rowData,
                            columns: columns,
                            isSelectRows: false,
                            currentPage: pageId,
                            currentPageSize: pageSize,
                            onChangePage: handleChangePage,
                            onChangePageSize: handleChangeRowsPerPage,
                            totalPage: totalPage,
                            totalAmount: totalAmount,
                            sortModel: sortModel,
                            onChangeSort: setSortModel,
                            handleSort: handleSort,
                            loading: loading
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalStatus,
                setModal: setModalStatus,
                htitle: "สถานะการใช้งาน",
                hbtn: false,
                children: /*#__PURE__*/ _jsx(StatusModal, {
                    setModal: setModalStatus,
                    modal: modalStatus,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj,
                    isMobile: isMobile
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalDel,
                setModal: setModalDel,
                htitle: modelText,
                hbtn: false,
                children: /*#__PURE__*/ _jsx(DelModel, {
                    setModal: setModalDel,
                    modal: modalDel,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj,
                    isMobile: isMobile
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalShop,
                setModal: setModalShop,
                htitle: modelText,
                hbtn: false,
                children: /*#__PURE__*/ _jsx(ShopModal, {
                    setModal: setModalShop,
                    modal: modalShop,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj
                })
            }),
            /*#__PURE__*/ _jsx(SuccessModal, {
                show: modalsuccess,
                onHide: function() {
                    return setModalsuccess(false);
                },
                textsuccess: textsuccess,
                navigate: navigate
            })
        ]
    });
}
export function ShopManageDatalist() {
    var accessToken = localStorage.getItem("accessToken");
    var adminInfo = getInfoAdminSystem(accessToken);
    var param = useParams();
    var shopId = useMemo(function() {
        return param.shopId ? param.shopId : null;
    }, [
        param.shopId
    ]);
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(""), 2), filterText = _useState[0], setFilterText = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), modelText = _useState1[0], setmodelText = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), filteredItems = _useState2[0], setFilteredItems = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), rowData = _useState3[0], setRowData = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), modalsuccess = _useState4[0], setModalsuccess = _useState4[1];
    var _useState5 = _sliced_to_array(useState(false), 2), textsuccess = _useState5[0], setTextsuccess = _useState5[1];
    var isSaleRole = Number(adminInfo.userRoleId) === 3;
    var _useState6 = _sliced_to_array(useState(isSaleRole ? Number(adminInfo.userId) : ""), 2), saleId = _useState6[0], setSaleId = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), optionSale = _useState7[0], setOptionSale = _useState7[1];
    var _useState8 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 0,
        width: !isMobile ? 500 : 300,
        height: 300,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modalDel = _useState8[0], setModalDel = _useState8[1];
    var _useState9 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 0,
        width: !isMobile ? 500 : 300,
        height: 300,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modalStatus = _useState9[0], setModalStatus = _useState9[1];
    var getDataShopBranchReducer = useAppSelector(function(state) {
        return state.getDataShopBranchReducer;
    });
    var getSaleuserReducer = useAppSelector(function(state) {
        return state.getSaleuserReducer;
    });
    useEffect(function() {
        var data = _object_spread({
            shopid: parseInt(shopId),
            status: null
        }, saleId && {
            saleid: parseInt(saleId)
        });
        dispatch(getDataShopBranch(data, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, [
        shopId,
        saleId
    ]);
    useEffect(function() {
        dispatch(getSaleuser({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, []);
    useEffect(function() {
        setIsLoading(getDataShopBranchReducer.isFetching);
        if (getDataShopBranchReducer.data) {
            var data = getDataShopBranchReducer.data.data;
            setRowData(data);
            setFilteredItems(data);
        }
    }, [
        getDataShopBranchReducer
    ]);
    useEffect(function() {
        if (getSaleuserReducer.data) {
            var saleOptions = (getSaleuserReducer.data.data || []).map(function(sale) {
                return {
                    value: sale.sys_user_id,
                    label: sale.sys_user_fullname
                };
            });
            setOptionSale(isSaleRole ? saleOptions.filter(function(sale) {
                return Number(sale.value) === Number(adminInfo.userId);
            }) : saleOptions);
        }
    }, [
        getSaleuserReducer
    ]);
    useEffect(function() {
        var searchText = filterText.trim().toLowerCase();
        if (searchText) {
            setRowData(filteredItems.filter(function(item) {
                var _item_sh_branch_name, _item_sh_branch_code;
                var branchName = ((_item_sh_branch_name = item.sh_branch_name) === null || _item_sh_branch_name === void 0 ? void 0 : _item_sh_branch_name.toLowerCase()) || "";
                var branchCode = ((_item_sh_branch_code = item.sh_branch_code) === null || _item_sh_branch_code === void 0 ? void 0 : _item_sh_branch_code.toLowerCase()) || "";
                return branchName.includes(searchText) || branchCode.includes(searchText);
            }));
        } else {
            setRowData(filteredItems);
        }
    }, [
        filteredItems,
        filterText
    ]);
    var columns = [
        {
            name: "รูปภาพ",
            selector: function(row) {
                return row.sh_branch_image;
            },
            center: "true",
            cell: function(row, index, column, id) {
                return row.sh_branch_image ? /*#__PURE__*/ _jsx("img", {
                    src: row.sh_branch_image,
                    loading: "lazy",
                    decoding: "async",
                    alt: "",
                    style: {
                        border: "1px outset #a8a8a8",
                        height: 90,
                        width: 90
                    }
                }) : /*#__PURE__*/ _jsx("span", {
                    className: "p-4",
                    style: {
                        border: "1px outset #a8a8a8",
                        height: 90,
                        width: 90
                    },
                    children: /*#__PURE__*/ _jsx(ImageIcon, {
                        style: {
                            fontSize: 40,
                            color: "#b00612"
                        }
                    })
                });
            }
        },
        {
            name: "ชื่อสาขาร้านค้า",
            selector: function(row) {
                return row.sh_branch_name;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            children: row.sh_branch_name
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "fs-12 tc-7 mt-1",
                            children: row.sh_branch_code
                        })
                    ]
                });
            }
        },
        {
            name: "ข้อมูลผู้ติดต่อ",
            selector: function(row) {
                return row.sh_branch_contactname;
            },
            cell: function(row, index, column, id) {
                return row.sh_branch_contactname ? /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            children: row.sh_branch_contactname
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "fs-12 tc-7 mt-1",
                            children: row.sh_branch_contactphone ? "โทร. ".concat(row.sh_branch_contactphone) : ""
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "fs-12 tc-7 mt-1",
                            children: row.sh_branch_contactwhatsapp ? "Id. ".concat(row.sh_branch_contactwhatsapp) : ""
                        })
                    ]
                }) : "";
            }
        },
        {
            name: "เงื่อนไข",
            selector: function(row) {
                return row.sh_branch_paystatus;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx("div", {
                        children: row.sh_branch_paystatus == 1 ? "เงินสด" : "เครดิต"
                    })
                });
            }
        },
        {
            name: "การคำนวณ VAT",
            selector: function(row) {
                return row.sh_branch_vatcal;
            },
            center: "true",
            cell: function(row) {
                return getVatCalLabel(row.sh_branch_vatcal);
            }
        },
        {
            name: "ระดับสาขา",
            selector: function(row) {
                return row.sh_branch_grade;
            },
            center: "true",
            cell: function(row) {
                return getBranchGradeLabel(row.sh_branch_grade);
            }
        },
        {
            name: "ผู้ดูแล",
            selector: function(row) {
                return row.sh_branch_intendantname;
            },
            center: "true"
        },
        {
            name: "วันที่สร้าง",
            selector: function(row) {
                return row.sh_branch_credate ? moment.parseZone(row.sh_branch_credate).format("DD/MM/YYYY HH:mm") : "-";
            },
            center: "true",
            width: "170px"
        },
        {
            name: "ระงับวงเงินเครดิต",
            selector: function(row) {
                return row.sh_branch_creditstatus;
            },
            center: "true",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx(Switch, {
                    checked: Number(row.sh_branch_creditstatus || 1) === 2,
                    disabled: adminInfo.userRoleId == 3,
                    sx: {
                        "& .MuiSwitch-switchBase.Mui-checked": {
                            color: "#dc3545"
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                            backgroundColor: "#dc3545"
                        }
                    },
                    onClick: function() {
                        setmodelText("ระงับวงเงินเครดิต");
                        setModalStatus(function(prev) {
                            return _object_spread_props(_object_spread({}, prev), {
                                open: true,
                                typeData: "shBranchCreditStatus",
                                data: {
                                    id: row.sh_branch_id,
                                    name: row.sh_branch_name,
                                    status: Number(row.sh_branch_creditstatus || 1)
                                }
                            });
                        });
                    }
                });
            }
        },
        {
            name: "สถานะการใช้งาน",
            selector: function(row) {
                return row.sh_branch_status;
            },
            center: "true",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx(Switch, {
                    checked: row.sh_branch_status == 1,
                    onClick: function() {
                        setmodelText("สถานะการใช้งาน");
                        setModalStatus(function(prev) {
                            return _object_spread_props(_object_spread({}, prev), {
                                open: true,
                                typeData: "shBranchStatus",
                                data: {
                                    id: row.sh_branch_id,
                                    name: row.sh_branch_name,
                                    status: row.sh_branch_status
                                }
                            });
                        });
                    }
                });
            }
        },
        {
            name: "จัดการ",
            width: "150px",
            selector: function(row) {
                return row.sh_branch_id;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex align-items-center gap-1",
                    children: [
                        /*#__PURE__*/ _jsx(Link, {
                            to: "/shop/manage/".concat(shopId, "/branch/").concat(row.sh_branch_id),
                            style: {
                                marginRight: 5
                            },
                            children: /*#__PURE__*/ _jsx(Tooltip, {
                                title: "แก้ไขสาขา",
                                children: /*#__PURE__*/ _jsx(EditIcon, {
                                    style: {
                                        color: "#797A7A",
                                        fontSize: 30,
                                        borderRadius: 40,
                                        background: "#E9E9E9",
                                        padding: 5
                                    }
                                })
                            })
                        }),
                        row.sh_branch_can_delete === false ? "" : /*#__PURE__*/ _jsx(Link, {
                            onClick: function() {
                                setModalDel(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true,
                                        typeData: "shBranchDel",
                                        data: {
                                            id: row.sh_branch_id,
                                            name: row.sh_branch_name
                                        }
                                    });
                                });
                                setmodelText("ยืนยันลบสาขา");
                            },
                            style: {
                                marginRight: 3
                            },
                            children: /*#__PURE__*/ _jsx(Tooltip, {
                                title: "ลบสาขา",
                                children: /*#__PURE__*/ _jsx(DeleteOutline, {
                                    style: {
                                        fontSize: 30,
                                        borderRadius: 40,
                                        background: "rgb(255, 227, 227)",
                                        color: "#FF0000",
                                        padding: 5
                                    }
                                })
                            })
                        }),
                        SHOW_SHOP_SYNC_BUTTONS && /*#__PURE__*/ _jsx(DataSyncControl, {
                            syncStatus: row.sh_branch_syncstatus,
                            rowData: row,
                            syncHandler: syncShopBranch,
                            syncPayload: function(data) {
                                return {
                                    branchid: data.sh_branch_id,
                                    postal_code: "",
                                    country: "",
                                    country_code: ""
                                };
                            },
                            syncHandlerOptions: {
                                modalObj: modalObj,
                                setModalObj: setModalObj
                            },
                            onSyncSuccess: function() {
                                return dispatch(getDataShopBranch({
                                    shopid: parseInt(shopId),
                                    status: null
                                }, {
                                    modalObj: modalObj,
                                    setModalObj: setModalObj
                                }));
                            }
                        })
                    ]
                });
            }
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: !isMobile ? "pagezoom" : "",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: !isMobile ? "breadcrumb fs-16 ps-0 mb-1" : "breadcrumb fs-14 ps-2 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "/shop",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการร้านค้า"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการสาขาร้านค้า"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: !isMobile ? "fs-24 mb-2" : "fs-20 mb-2 ps-2",
                        children: "สาขาร้านค้า"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsxs(Card, {
                    children: [
                        /*#__PURE__*/ _jsx(CardBody, {
                            children: /*#__PURE__*/ _jsxs(Row, {
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 4,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-3 form-st-3 p-0",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1 z-3",
                                                    children: "เซลล์ผู้ดูแล"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, {
                                                    className: "w-100 select-st-3 z-2",
                                                    placeholder: "เลือกเซลล์ผู้ดูแล",
                                                    options: optionSale,
                                                    value: optionSale.find(function(opt) {
                                                        return Number(opt.value) === Number(saleId);
                                                    }) || "",
                                                    onChange: function(e) {
                                                        return setSaleId(e ? e.value : "");
                                                    },
                                                    isClearable: !isSaleRole,
                                                    isDisabled: isSaleRole
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 0,
                                        md: 0,
                                        lg: 3
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 12,
                                        lg: 3,
                                        children: /*#__PURE__*/ _jsx("input", {
                                            type: "text",
                                            className: "form-control me-3 mb-3",
                                            placeholder: "ค้นหารายการ",
                                            onKeyUp: function(e) {
                                                return setFilterText(e.target.value);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 12,
                                        lg: 2,
                                        children: /*#__PURE__*/ _jsx(Link, {
                                            className: "btn btn-dg w-[100%] mb-3",
                                            to: "/shop/manage/".concat(shopId, "/branch"),
                                            children: "สร้างสาขาร้านค้า"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(DataTableLayout, {
                            item: rowData,
                            columns: columns,
                            isSelectRows: false,
                            PerPage: 10
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalStatus,
                setModal: setModalStatus,
                htitle: modelText,
                hbtn: false,
                children: /*#__PURE__*/ _jsx(StatusModal, {
                    setModal: setModalStatus,
                    modal: modalStatus,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj,
                    shopId: shopId,
                    isMobile: isMobile
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalDel,
                setModal: setModalDel,
                htitle: modelText,
                hbtn: false,
                children: /*#__PURE__*/ _jsx(DelModel, {
                    setModal: setModalDel,
                    modal: modalDel,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj,
                    shopId: shopId,
                    isMobile: isMobile
                })
            }),
            /*#__PURE__*/ _jsx(SuccessModal, {
                show: modalsuccess,
                onHide: function() {
                    return setModalsuccess(false);
                },
                textsuccess: textsuccess,
                navigate: navigate
            })
        ]
    });
}
export function ShopModal(param) {
    var modal = param.modal, setModal = param.setModal, setTextsuccess = param.setTextsuccess, setModalsuccess = param.setModalsuccess, setIsLoading = param.setIsLoading, setModalObj = param.setModalObj, modalObj = param.modalObj;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(""), 2), name = _useState[0], setName = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), id = _useState1[0], setId = _useState1[1];
    var _useState2 = _sliced_to_array(useState(1), 2), shops = _useState2[0], setShops = _useState2[1];
    var updateShopReducer = useAppSelector(function(state) {
        return state.updateShopReducer;
    });
    useEffect(function() {
        if (modal.data == null) {
            setName("");
            setId(0);
            setShops(1);
        }
        if (modal.data != null) {
            var vul = modal.data;
            setName(vul.name);
            setId(vul.id);
            setShops(vul.typrShop);
        }
    }, [
        modal.data,
        modal.open
    ]);
    var onClickModel = function() {
        var data = {
            sh_shop_id: id,
            sh_shop_name: name,
            sh_shop_typeshop: shops
        };
        dispatch(updateShop(data, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    useEffect(function() {
        setIsLoading(updateShopReducer.isFetching);
        if (updateShopReducer.data && !updateShopReducer.isError) {
            setTextsuccess("แก้ไขสถานะร้านค้าสำเร็จ");
            setModalsuccess(true);
            dispatch(clearupdateShop());
            dispatch(getDataShop(null, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setName("");
            setId(0);
        }
    }, [
        updateShopReducer
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "row gx-xl-4",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "col-xl-12 col-md-12",
                children: [
                    /*#__PURE__*/ _jsxs(Form.Group, {
                        className: "mb-2 form-st-3 pb-1",
                        children: [
                            /*#__PURE__*/ _jsx(Form.Label, {
                                className: "mb-1",
                                children: "ชื่อร้านค้า"
                            }),
                            /*#__PURE__*/ _jsx(Form.Control, {
                                type: "text",
                                className: "form-control ".concat(name ? "" : !name ? "is-invalid" : ""),
                                placeholder: "ชื่อร้านค้า",
                                value: name,
                                onChange: function(e) {
                                    setName(e.target.value);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "fs-14 tc-5 pl-3",
                        children: "** กรอกชื่อร้านค้า เป็น ภาษาลาว หรือ ภาษาอังกฤษ เท่านั้น"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "col-xl-12 col-md-12",
                children: [
                    /*#__PURE__*/ _jsx(Form.Label, {
                        className: "mb-2 tc-10",
                        children: "ประเภทร้านค้า"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx(Form.Check, {
                                inline: true,
                                type: "radio",
                                id: "p-radio-1",
                                label: "RT",
                                checked: shops == 1 ? true : false,
                                className: "form-check-st-2 tc-7 mt-0",
                                onChange: function() {
                                    setShops(1);
                                }
                            }),
                            /*#__PURE__*/ _jsx(Form.Check, {
                                inline: true,
                                type: "radio",
                                id: "p-radio-2",
                                label: "WT",
                                checked: shops == 2 ? true : false,
                                className: "form-check-st-2 tc-7 mt-0",
                                onChange: function() {
                                    setShops(2);
                                }
                            }),
                            /*#__PURE__*/ _jsx(Form.Check, {
                                inline: true,
                                type: "radio",
                                id: "p-radio-2",
                                label: "MT",
                                checked: shops == 3 ? true : false,
                                className: "form-check-st-2 tc-7 mt-0",
                                onChange: function() {
                                    setShops(3);
                                }
                            })
                        ]
                    }, "p-radio")
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col-xl-12 col-md-12",
                children: /*#__PURE__*/ _jsxs(Stack, {
                    direction: "row",
                    justifyContent: "flex-end",
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            className: "btn-st-6 me-3 btn py-2 px-3 mt-4",
                            onClick: function() {
                                return setModal(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            children: "ยกเลิก"
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            className: "mt-4 btn btn-dg w-400",
                            onClick: function(e) {
                                onClickModel();
                            },
                            children: "บันทึก"
                        })
                    ]
                })
            })
        ]
    });
}
export function ShopManage() {
    var accessToken = localStorage.getItem("accessToken");
    var adminInfo = getInfoAdminSystem(accessToken);
    var param = useParams();
    var shopId = useMemo(function() {
        return param.shopId ? param.shopId : null;
    }, [
        param.shopId
    ]);
    var branchId = useMemo(function() {
        return param.branchId ? param.branchId : null;
    }, [
        param.branchId
    ]);
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useState = _sliced_to_array(useState(false), 2), modalsuccess = _useState[0], setModalsuccess = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), textsuccess = _useState1[0], setTextsuccess = _useState1[1];
    var _useState2 = _sliced_to_array(useState({}), 2), formdata = _useState2[0], setFormdata = _useState2[1];
    var _useState3 = _sliced_to_array(useState(1), 2), status = _useState3[0], setStatus = _useState3[1];
    var _useState4 = _sliced_to_array(useState(1), 2), pay = _useState4[0], setPay = _useState4[1];
    var _useState5 = _sliced_to_array(useState(1), 2), creditStatus = _useState5[0], setCreditStatus = _useState5[1];
    var _useState6 = _sliced_to_array(useState(1), 2), vatCal = _useState6[0], setVatCal = _useState6[1];
    var _useState7 = _sliced_to_array(useState(1), 2), shops = _useState7[0], setShops = _useState7[1];
    var _useState8 = _sliced_to_array(useState(1), 2), branchGrade = _useState8[0], setBranchGrade = _useState8[1];
    var isSalesBranchEdit = adminInfo.userRoleId == 3 && Boolean(branchId);
    var _useState9 = _sliced_to_array(useState([]), 2), opIntendant = _useState9[0], setOpIntendant = _useState9[1];
    var _useState10 = _sliced_to_array(useState([]), 2), shippingOptions = _useState10[0], setShippingOptions = _useState10[1];
    var shippingSelectMenuProps = useMemo(function() {
        return {
            menuPortalTarget: typeof document !== "undefined" ? document.body : undefined,
            menuPosition: "fixed",
            menuPlacement: "auto",
            maxMenuHeight: 240,
            styles: {
                menuPortal: function(base) {
                    return _object_spread_props(_object_spread({}, base), {
                        zIndex: 9999
                    });
                },
                menu: function(base) {
                    return _object_spread_props(_object_spread({}, base), {
                        zIndex: 9999
                    });
                }
            }
        };
    }, []);
    var _useState11 = _sliced_to_array(useState(""), 2), imgPath = _useState11[0], setImgPath = _useState11[1];
    var _useState12 = _sliced_to_array(useState(""), 2), textImg = _useState12[0], setTextImg = _useState12[1];
    var _useState13 = _sliced_to_array(useState(""), 2), nameImg = _useState13[0], setNameImg = _useState13[1];
    var schema = yup.object().shape({
        sh_shop_name: yup.string().required(),
        sh_branch_name: yup.string().required(),
        sh_branch_countriesid: yup.number().positive("กรุณาเลือกประเทศ").required("กรุณาเลือกประเทศ"),
        sh_branch_contactname: yup.string().required(),
        sh_branch_contactphone: yup.string().required(),
        sh_branch_ggmaplat: yup.string().trim().required("กรุณากรอก Lat"),
        sh_branch_ggmaplong: yup.string().trim().required("กรุณากรอก Long"),
        sh_branch_intendant: adminInfo.userRoleId != 3 ? yup.string().required() : ""
    });
    var createShopReducer = useAppSelector(function(state) {
        return state.createShopReducer;
    });
    var uploadShopReducer = useAppSelector(function(state) {
        return state.uploadShopReducer;
    });
    var getSaleuserReducer = useAppSelector(function(state) {
        return state.getSaleuserReducer;
    });
    var getDataShopByIdReducer = useAppSelector(function(state) {
        return state.getDataShopByIdReducer;
    });
    var getDataShopBranchByIdReducer = useAppSelector(function(state) {
        return state.getDataShopBranchByIdReducer;
    });
    var createShBranchReducer = useAppSelector(function(state) {
        return state.createShBranchReducer;
    });
    var updateShBranchReducer = useAppSelector(function(state) {
        return state.updateShBranchReducer;
    });
    useEffect(function() {
        if (shopId) {
            var data = {
                shshopid: parseInt(shopId),
                status: null
            };
            dispatch(getDataShopById(data, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
        if (branchId) {
            var data1 = {
                branchid: parseInt(branchId),
                status: null
            };
            dispatch(getDataShopBranchById(data1, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
        dispatch(getSaleuser({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        var active = true;
        http.get(endPoint.SET_SHIPPING, {
            headers: {
                Authorization: "Bearer ".concat(accessToken)
            }
        }).then(function(response) {
            var _response_data;
            if (!active) return;
            var _response_data_data, _ref;
            var rows = (_ref = (_response_data_data = response === null || response === void 0 ? void 0 : (_response_data = response.data) === null || _response_data === void 0 ? void 0 : _response_data.data) !== null && _response_data_data !== void 0 ? _response_data_data : response === null || response === void 0 ? void 0 : response.data) !== null && _ref !== void 0 ? _ref : [];
            setShippingOptions(rows.map(function(item) {
                return {
                    value: item.set_shipping_id,
                    label: item.set_shipping_name
                };
            }));
        }).catch(function() {
            if (active) setShippingOptions([]);
        });
        return function() {
            active = false;
        };
    }, []);
    var handlePreviewimage = function(e) {
        if (e.target.files[0]) {
            var formData = new FormData();
            formData.append("upload_shshop", e.target.files[0]);
            dispatch(uploadShop(formData, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setTextImg("shop");
        }
    };
    useEffect(function() {
        if (textImg == "shop") {
            setIsLoading(uploadShopReducer.isFetching);
            if (uploadShopReducer.data) {
                console.log("uploadShopReducer", uploadShopReducer.data.data[0]);
                setImgPath(uploadShopReducer.data.data[0].imgFilePath);
                setNameImg(uploadShopReducer.data.data[0].imgoriginalname);
                dispatch(clearuploadShop());
                setTextImg("");
            }
        }
    }, [
        uploadShopReducer
    ]);
    useEffect(function() {
        setIsLoading(createShopReducer.isFetching || getSaleuserReducer.isFetching || getDataShopByIdReducer.isFetching || getDataShopBranchByIdReducer.isFetching || updateShBranchReducer.isFetching);
        if (createShopReducer.data && !createShopReducer.isError) {
            setTextsuccess("สร้างร้านค้าสำเร็จ");
            setModalsuccess(true);
            dispatch(clearcreateShop());
        }
        if (createShBranchReducer.data && !createShBranchReducer.isError) {
            setTextsuccess("สร้างสาขาร้านค้าสำเร็จ");
            setModalsuccess(true);
            dispatch(clearcreateShBranch());
        }
        if (updateShBranchReducer.data && !updateShBranchReducer.isError) {
            setTextsuccess("แก้ไขสาขาร้านค้าสำเร็จ");
            setModalsuccess(true);
            dispatch(clearupdateShBranch());
        }
        if (getSaleuserReducer.data) {
            var arr = [];
            getSaleuserReducer.data.data.map(function(ele) {
                return arr.push({
                    value: ele.sys_user_id,
                    label: ele.sys_user_fullname
                });
            });
            setOpIntendant(arr);
        }
        if (shopId) {
            if (getDataShopByIdReducer.data) {
                setFormdata({
                    sh_shop_name: getDataShopByIdReducer.data.data[0].sh_shop_name
                });
                setShops(getDataShopByIdReducer.data.data[0].sh_shop_typeshop || 0);
            }
        }
        if (branchId) {
            if (getDataShopBranchByIdReducer.data && getDataShopByIdReducer.data) {
                var dataShop = getDataShopBranchByIdReducer.data.data[0];
                setFormdata(_object_spread_props(_object_spread({}, shopAddressIds(dataShop)), {
                    sh_branch_name: dataShop.sh_branch_name ? dataShop.sh_branch_name : "",
                    sh_branch_shortname: dataShop.sh_branch_shortname || "",
                    sh_branch_village: dataShop.sh_branch_village || "",
                    sh_branch_district: dataShop.sh_branch_district || "",
                    sh_branch_province: dataShop.sh_branch_province || "",
                    sh_branch_address: dataShop.sh_branch_address ? dataShop.sh_branch_address : "",
                    sh_branch_recipient_name: dataShop.sh_branch_recipient_name || "",
                    sh_branch_recipient_phone: dataShop.sh_branch_recipient_phone || "",
                    sh_branch_shippingid: dataShop.sh_branch_shippingid || null,
                    sh_branch_shipping_paytype: dataShop.sh_branch_shipping_paytype || 1,
                    sh_branch_contactname: dataShop.sh_branch_contactname ? dataShop.sh_branch_contactname : "",
                    sh_branch_contactphone: dataShop.sh_branch_contactphone ? dataShop.sh_branch_contactphone : "",
                    sh_branch_contactwhatsapp: dataShop.sh_branch_contactwhatsapp ? dataShop.sh_branch_contactwhatsapp : "",
                    sh_branch_suptactname: dataShop.sh_branch_suptactname ? dataShop.sh_branch_suptactname : "",
                    sh_branch_suptactphone: dataShop.sh_branch_suptactphone ? dataShop.sh_branch_suptactphone : "",
                    sh_branch_suptactwhatsapp: dataShop.sh_branch_suptactwhatsapp ? dataShop.sh_branch_suptactwhatsapp : "",
                    sh_branch_ggmaplink: dataShop.sh_branch_ggmaplink ? dataShop.sh_branch_ggmaplink : "",
                    sh_branch_ggmaplat: dataShop.sh_branch_ggmaplat ? dataShop.sh_branch_ggmaplat : "",
                    sh_branch_ggmaplong: dataShop.sh_branch_ggmaplong ? dataShop.sh_branch_ggmaplong : "",
                    sh_branch_creditday: dataShop.sh_branch_creditday ? dataShop.sh_branch_creditday : 0,
                    sh_branch_intendant: dataShop.sh_branch_intendant ? dataShop.sh_branch_intendant : "",
                    sh_shop_name: getDataShopByIdReducer.data.data[0].sh_shop_name
                }));
                setPay(dataShop.sh_branch_paystatus);
                setCreditStatus(dataShop.sh_branch_creditstatus || 1);
                setVatCal(dataShop.sh_branch_vatcal || 1);
                setShops(getDataShopByIdReducer.data.data[0].sh_shop_typeshop);
                setBranchGrade(dataShop.sh_branch_grade > 0 ? dataShop.sh_branch_grade : 1);
                setStatus(dataShop.sh_branch_status);
                setImgPath(dataShop.sh_branch_image);
                setNameImg(dataShop.sh_branch_imagename);
            }
        }
    }, [
        createShopReducer,
        getSaleuserReducer,
        getDataShopByIdReducer,
        getDataShopBranchByIdReducer,
        createShBranchReducer,
        updateShBranchReducer
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: !isMobile ? "pagezoom" : "",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: !isMobile ? "breadcrumb fs-16 ps-0 mb-1" : "breadcrumb fs-14 ps-2 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "/shop",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการร้านค้า"
                                    })
                                }),
                                !shopId && !branchId && /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "สร้างร้านค้า"
                                    })
                                }),
                                shopId && /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "/shop/manage/".concat(shopId),
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการสาขาร้านค้า"
                                    })
                                }),
                                shopId && !branchId && /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsxs("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: [
                                            "สร้างสาขาร้านค้า",
                                            " ",
                                            formdata.sh_shop_name ? formdata.sh_shop_name : ""
                                        ]
                                    })
                                }),
                                branchId && /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "แก้ไขสาขาร้านค้า ".concat(formdata.sh_shop_name ? formdata.sh_shop_name : "")
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: !isMobile ? "fs-24 mb-2" : "fs-20 mb-2 ps-2",
                        children: !shopId && !branchId && "สร้างร้านค้า" || branchId && "แก้ไขสาขาร้านค้า\n                  ".concat(formdata.sh_shop_name ? formdata.sh_shop_name : "", "\n              ") || shopId && !branchId && "สร้างสาขาร้านค้า ".concat(formdata.sh_shop_name ? formdata.sh_shop_name : "")
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Formik, {
                enableReinitialize: true,
                initialValues: formdata,
                validationSchema: schema,
                validateOnMount: true,
                onSubmit: function(values) {
                    var _values_sh_branch_shortname, _values_sh_branch_village, _values_sh_branch_district, _values_sh_branch_province, _values_sh_branch_recipient_name, _values_sh_branch_recipient_phone;
                    var formdataPayload = new FormData();
                    console.log("formdataPayload", formdataPayload);
                    var dataForm = _object_spread_props(_object_spread({
                        sh_branch_id: branchId ? parseInt(branchId) : null,
                        sh_branch_shid: shopId ? parseInt(shopId) : null,
                        sh_shop_name: values.sh_shop_name,
                        sh_branch_image: imgPath,
                        sh_branch_imagename: nameImg,
                        sh_branch_name: values.sh_branch_name,
                        sh_branch_shortname: ((_values_sh_branch_shortname = values.sh_branch_shortname) === null || _values_sh_branch_shortname === void 0 ? void 0 : _values_sh_branch_shortname.trim()) || ""
                    }, shopAddressIds(values)), {
                        sh_branch_village: ((_values_sh_branch_village = values.sh_branch_village) === null || _values_sh_branch_village === void 0 ? void 0 : _values_sh_branch_village.trim()) || "",
                        sh_branch_district: ((_values_sh_branch_district = values.sh_branch_district) === null || _values_sh_branch_district === void 0 ? void 0 : _values_sh_branch_district.trim()) || "",
                        sh_branch_province: ((_values_sh_branch_province = values.sh_branch_province) === null || _values_sh_branch_province === void 0 ? void 0 : _values_sh_branch_province.trim()) || "",
                        sh_branch_address: values.sh_branch_address || "",
                        sh_branch_recipient_name: ((_values_sh_branch_recipient_name = values.sh_branch_recipient_name) === null || _values_sh_branch_recipient_name === void 0 ? void 0 : _values_sh_branch_recipient_name.trim()) || "",
                        sh_branch_recipient_phone: ((_values_sh_branch_recipient_phone = values.sh_branch_recipient_phone) === null || _values_sh_branch_recipient_phone === void 0 ? void 0 : _values_sh_branch_recipient_phone.trim()) || "",
                        sh_branch_shippingid: values.sh_branch_shippingid ? Number(values.sh_branch_shippingid) : null,
                        sh_branch_shipping_paytype: Number(values.sh_branch_shipping_paytype || 1),
                        sh_branch_contactname: values.sh_branch_contactname,
                        sh_branch_contactphone: values.sh_branch_contactphone,
                        sh_branch_contactwhatsapp: values.sh_branch_contactwhatsapp,
                        sh_branch_suptactname: values.sh_branch_suptactname,
                        sh_branch_suptactphone: values.sh_branch_suptactphone,
                        sh_branch_suptactwhatsapp: values.sh_branch_suptactwhatsapp,
                        sh_branch_ggmaplink: values.sh_branch_ggmaplink,
                        sh_branch_ggmaplat: values.sh_branch_ggmaplat,
                        sh_branch_ggmaplong: values.sh_branch_ggmaplong,
                        sh_branch_paystatus: pay,
                        sh_branch_creditday: values.sh_branch_creditday ? parseInt(values.sh_branch_creditday) : 0,
                        sh_branch_creditstatus: creditStatus,
                        sh_branch_vatcal: vatCal,
                        sh_branch_grade: branchGrade,
                        sh_shop_typeshop: shops,
                        sh_branch_intendant: adminInfo.userRoleId != 3 ? values.sh_branch_intendant : adminInfo.userId,
                        sh_branch_status: status
                    });
                    if (shopId && !branchId) {
                        dispatch(createShBranch(dataForm, {
                            modalObj: modalObj,
                            setModalObj: setModalObj
                        }));
                    } else if (shopId && branchId) {
                        dispatch(updateShBranch(dataForm, {
                            modalObj: modalObj,
                            setModalObj: setModalObj
                        }));
                    } else {
                        dispatch(createShop(dataForm, {
                            modalObj: modalObj,
                            setModalObj: setModalObj
                        }));
                    }
                },
                children: function(param) {
                    var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, setValues = param.setValues, isInvalid = param.isInvalid, isValid = param.isValid, setTouched = param.setTouched, validateForm = param.validateForm;
                    return /*#__PURE__*/ _jsxs(Form, {
                        noValidate: true,
                        onSubmit: function(e) {
                            e.preventDefault();
                        },
                        children: [
                            /*#__PURE__*/ _jsxs("fieldset", {
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: !isMobile ? "card pagezoom card-st-3 mb-1" : "card card-st-3 mb-1",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "card-body px-xl-3",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "pt-3",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "col-xl-6 col-md-12",
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "ชื่อร้านค้า"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "sh_shop_name",
                                                                                className: "form-control",
                                                                                placeholder: "กรอกชื่อร้านค้า",
                                                                                value: values.sh_shop_name,
                                                                                isInvalid: !!errors.sh_shop_name,
                                                                                disabled: shopId ? true : false,
                                                                                onChange: function(e) {
                                                                                    setValues(_object_spread_props(_object_spread({}, values), {
                                                                                        sh_shop_name: e.target.value
                                                                                    }));
                                                                                }
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "fs-14 tc-5 pl-3",
                                                                        children: "** กรอกชื่อร้านค้า เป็น ภาษาลาว หรือ ภาษาอังกฤษ เท่านั้น"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "col-xl-6 col-md-12",
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "สาขา"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "sh_branch_name",
                                                                                className: "form-control",
                                                                                placeholder: "กรอกสาขา",
                                                                                value: values.sh_branch_name,
                                                                                isInvalid: !!errors.sh_branch_name,
                                                                                onChange: function(e) {
                                                                                    setValues(_object_spread_props(_object_spread({}, values), {
                                                                                        sh_branch_name: e.target.value
                                                                                    }));
                                                                                }
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "fs-14 tc-5 pl-3",
                                                                        children: '** กรอกสาขา เป็น ภาษาลาว หรือ ภาษาอังกฤษ เท่านั้น ถ้าไม่มีสาขาให้ใส่ "ສໍານັກງານໃຫຍ່"'
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "col-xl-6 col-md-12 mt-2",
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "ชื่อย่อร้านค้า"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "sh_branch_shortname",
                                                                                className: "form-control",
                                                                                placeholder: "กรอกชื่อย่อร้านค้า",
                                                                                value: values.sh_branch_shortname || "",
                                                                                onChange: handleChange
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "fs-14 tc-5 pl-3",
                                                                        children: "** กรอกชื่อย่อร้านค้า เป็น ภาษาไทย เท่านั้น"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "col-xl-12 col-md-12",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                        className: "mb-2 tc-10",
                                                                        children: "ประเภทร้านค้า"
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Check, {
                                                                                inline: true,
                                                                                type: "radio",
                                                                                id: "p-radio-1",
                                                                                label: "RT",
                                                                                checked: shops == 1 ? true : false,
                                                                                className: "form-check-st-2 tc-7 mt-0",
                                                                                disabled: shopId ? true : false,
                                                                                onChange: function() {
                                                                                    setShops(1);
                                                                                }
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Check, {
                                                                                inline: true,
                                                                                type: "radio",
                                                                                id: "p-radio-2",
                                                                                label: "WT",
                                                                                checked: shops == 2 ? true : false,
                                                                                className: "form-check-st-2 tc-7 mt-0",
                                                                                disabled: shopId ? true : false,
                                                                                onChange: function() {
                                                                                    setShops(2);
                                                                                }
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Check, {
                                                                                inline: true,
                                                                                type: "radio",
                                                                                id: "p-radio-2",
                                                                                label: "MT",
                                                                                checked: shops == 3 ? true : false,
                                                                                className: "form-check-st-2 tc-7 mt-0",
                                                                                disabled: shopId ? true : false,
                                                                                onChange: function() {
                                                                                    setShops(3);
                                                                                }
                                                                            })
                                                                        ]
                                                                    }, "p-radio")
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "col-xl-12 col-md-12 mt-2",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                        className: "mb-2 tc-10",
                                                                        children: "ระดับสาขา"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        children: BRANCH_GRADE_OPTIONS.map(function(option) {
                                                                            return /*#__PURE__*/ _jsx(Form.Check, {
                                                                                inline: true,
                                                                                type: "radio",
                                                                                id: "branch-grade-form-".concat(option.value),
                                                                                label: option.label,
                                                                                checked: branchGrade == option.value ? true : false,
                                                                                className: "form-check-st-2 tc-7 mt-0",
                                                                                disabled: isSalesBranchEdit,
                                                                                onChange: function() {
                                                                                    setBranchGrade(option.value);
                                                                                }
                                                                            }, "branch-grade-form-".concat(option.value));
                                                                        })
                                                                    }, "branch-grade-form-radio")
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-12 col-md-12",
                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                    className: "fw-bold fs-18 mb-2 mt-3",
                                                                    children: "ที่อยู่ร้านค้า"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx(ShopAddressSelect, {
                                                                values: values,
                                                                error: touched.sh_branch_countriesid && errors.sh_branch_countriesid,
                                                                onChange: function(address) {
                                                                    return setValues(function(current) {
                                                                        return _object_spread({}, current, address);
                                                                    });
                                                                }
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-12 col-md-12",
                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                    className: "fw-bold fs-18 mb-2 mt-3",
                                                                    children: "ผู้ติดต่อ 1"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-4 col-md-12",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "ชื่อผู้ติดต่อ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "sh_branch_contactname",
                                                                            className: "form-control",
                                                                            placeholder: "กรอกชื่อผู้ติดต่อ",
                                                                            value: values.sh_branch_contactname,
                                                                            isInvalid: !!errors.sh_branch_contactname,
                                                                            onChange: function(e) {
                                                                                setValues(_object_spread_props(_object_spread({}, values), {
                                                                                    sh_branch_contactname: e.target.value
                                                                                }));
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-4 col-md-12",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "เบอร์ผู้ติดต่อ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "sh_branch_contactphone",
                                                                            className: "form-control",
                                                                            placeholder: "กรอกเบอร์ผู้ติดต่อ",
                                                                            value: values.sh_branch_contactphone,
                                                                            isInvalid: !!errors.sh_branch_contactphone,
                                                                            onChange: function(e) {
                                                                                setValues(_object_spread_props(_object_spread({}, values), {
                                                                                    sh_branch_contactphone: e.target.value
                                                                                }));
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-4 col-md-12",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "What App ผู้ติดต่อ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "sh_branch_contactwhatsapp",
                                                                            className: "form-control",
                                                                            placeholder: "กรอก WhatApp ผู้ติดต่อ",
                                                                            value: values.sh_branch_contactwhatsapp,
                                                                            onChange: function(e) {
                                                                                setValues(_object_spread_props(_object_spread({}, values), {
                                                                                    sh_branch_contactwhatsapp: e.target.value
                                                                                }));
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-12 col-md-12",
                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                    className: "fw-bold fs-18 mb-2",
                                                                    children: "ผู้ติดต่อ 2"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-4 col-md-12",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "ชื่อผู้ติดต่อ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "sh_branch_suptactname",
                                                                            className: "form-control",
                                                                            placeholder: "กรอกชื่อผู้ติดต่อ",
                                                                            value: values.sh_branch_suptactname,
                                                                            isInvalid: !!errors.sh_branch_suptactname,
                                                                            onChange: function(e) {
                                                                                setValues(_object_spread_props(_object_spread({}, values), {
                                                                                    sh_branch_suptactname: e.target.value
                                                                                }));
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-4 col-md-12",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "เบอร์ผู้ติดต่อ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "sh_branch_suptactphone",
                                                                            className: "form-control",
                                                                            placeholder: "กรอกเบอร์ผู้ติดต่อ",
                                                                            value: values.sh_branch_suptactphone,
                                                                            isInvalid: !!errors.sh_branch_suptactphone,
                                                                            onChange: function(e) {
                                                                                setValues(_object_spread_props(_object_spread({}, values), {
                                                                                    sh_branch_suptactphone: e.target.value
                                                                                }));
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-4 col-md-12",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "What App ผู้ติดต่อ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "sh_branch_suptactwhatsapp",
                                                                            className: "form-control",
                                                                            placeholder: "กรอก WhatApp ผู้ติดต่อ",
                                                                            value: values.sh_branch_suptactwhatsapp,
                                                                            onChange: function(e) {
                                                                                setValues(_object_spread_props(_object_spread({}, values), {
                                                                                    sh_branch_suptactwhatsapp: e.target.value
                                                                                }));
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-4 col-md-12",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "Google Map link"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "sh_branch_ggmaplink",
                                                                            className: "form-control",
                                                                            placeholder: "กรอก Google Map link",
                                                                            value: values.sh_branch_ggmaplink,
                                                                            onChange: function(e) {
                                                                                setValues(_object_spread_props(_object_spread({}, values), {
                                                                                    sh_branch_ggmaplink: e.target.value
                                                                                }));
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-4 col-md-12",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: [
                                                                                "Lat ",
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    className: "text-danger",
                                                                                    children: "*"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "sh_branch_ggmaplat",
                                                                            className: "form-control",
                                                                            placeholder: "กรอก Lat",
                                                                            value: values.sh_branch_ggmaplat || "",
                                                                            isInvalid: !!errors.sh_branch_ggmaplat,
                                                                            onChange: function(e) {
                                                                                setValues(_object_spread_props(_object_spread({}, values), {
                                                                                    sh_branch_ggmaplat: e.target.value
                                                                                }));
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control.Feedback, {
                                                                            type: "invalid",
                                                                            children: errors.sh_branch_ggmaplat
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-4 col-md-12",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: [
                                                                                "Long ",
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    className: "text-danger",
                                                                                    children: "*"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "sh_branch_ggmaplong",
                                                                            className: "form-control",
                                                                            placeholder: "กรอก Long",
                                                                            value: values.sh_branch_ggmaplong || "",
                                                                            isInvalid: !!errors.sh_branch_ggmaplong,
                                                                            onChange: function(e) {
                                                                                setValues(_object_spread_props(_object_spread({}, values), {
                                                                                    sh_branch_ggmaplong: e.target.value
                                                                                }));
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control.Feedback, {
                                                                            type: "invalid",
                                                                            children: errors.sh_branch_ggmaplong
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "col-xl-4 col-md-12",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                        className: "mb-2  tc-10",
                                                                        children: "เงื่อนไข"
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs(Stack, {
                                                                        direction: "row",
                                                                        justifyContent: "flex-start",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsxs("div", {
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Check, {
                                                                                        inline: true,
                                                                                        type: "radio",
                                                                                        id: "p-radio-1",
                                                                                        label: "เงินสด",
                                                                                        checked: pay == 1 ? true : false,
                                                                                        className: "form-check-st-2 tc-7 mt-1",
                                                                                        disabled: isSalesBranchEdit,
                                                                                        onChange: function() {
                                                                                            setPay(1);
                                                                                            setFieldValue("sh_branch_creditday", "");
                                                                                        }
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Form.Check, {
                                                                                        inline: true,
                                                                                        type: "radio",
                                                                                        id: "p-radio-2",
                                                                                        label: "เครดิต",
                                                                                        checked: pay == 2 ? true : false,
                                                                                        className: "form-check-st-2 tc-7 mt-1",
                                                                                        disabled: isSalesBranchEdit,
                                                                                        onChange: function() {
                                                                                            setPay(2);
                                                                                        }
                                                                                    })
                                                                                ]
                                                                            }, "p-radio"),
                                                                            pay == 2 && /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "sh_branch_creditday",
                                                                                className: "form-control w-[150px] me-3",
                                                                                placeholder: "จำนวนวันเครดิต",
                                                                                value: values.sh_branch_creditday,
                                                                                disabled: isSalesBranchEdit,
                                                                                onChange: function(e) {
                                                                                    setValues(_object_spread_props(_object_spread({}, values), {
                                                                                        sh_branch_creditday: e.target.value
                                                                                    }));
                                                                                }
                                                                            }),
                                                                            pay == 2 && /*#__PURE__*/ _jsx("span", {
                                                                                className: "mt-2",
                                                                                children: "วัน"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "col-xl-4 col-md-12",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                        className: "mb-2  tc-10",
                                                                        children: "ระงับวงเงินเครดิต"
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Check, {
                                                                                inline: true,
                                                                                type: "radio",
                                                                                id: "credit-status-radio-1",
                                                                                label: "ปกติ",
                                                                                checked: creditStatus == 1 ? true : false,
                                                                                className: "form-check-st-2 tc-7 mt-0",
                                                                                disabled: isSalesBranchEdit,
                                                                                onChange: function() {
                                                                                    setCreditStatus(1);
                                                                                }
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Check, {
                                                                                inline: true,
                                                                                type: "radio",
                                                                                id: "credit-status-radio-2",
                                                                                label: "ระงับ",
                                                                                checked: creditStatus == 2 ? true : false,
                                                                                className: "form-check-st-2 tc-7 mt-0",
                                                                                disabled: isSalesBranchEdit,
                                                                                onChange: function() {
                                                                                    setCreditStatus(2);
                                                                                }
                                                                            })
                                                                        ]
                                                                    }, "credit-status-radio")
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "col-xl-4 col-md-12",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                        className: "mb-2  tc-10",
                                                                        children: "การคำนวณ VAT"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        children: VAT_CAL_OPTIONS.map(function(option) {
                                                                            return /*#__PURE__*/ _jsx(Form.Check, {
                                                                                inline: true,
                                                                                type: "radio",
                                                                                id: "vat-cal-radio-".concat(option.value),
                                                                                label: option.label,
                                                                                checked: vatCal == option.value ? true : false,
                                                                                className: "form-check-st-2 tc-7 mt-0",
                                                                                disabled: isSalesBranchEdit,
                                                                                onChange: function() {
                                                                                    setVatCal(option.value);
                                                                                }
                                                                            }, "vat-cal-radio-".concat(option.value));
                                                                        })
                                                                    }, "vat-cal-radio")
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "col-xl-4 col-md-12",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                        className: "mb-2  tc-10",
                                                                        children: "สถานะการใช้งาน"
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Check, {
                                                                                inline: true,
                                                                                type: "radio",
                                                                                id: "p-radio-1",
                                                                                label: "เปิดใช้งาน",
                                                                                checked: status == 1 ? true : false,
                                                                                className: "form-check-st-2 tc-7 mt-0",
                                                                                onChange: function() {
                                                                                    setStatus(1);
                                                                                }
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Check, {
                                                                                inline: true,
                                                                                type: "radio",
                                                                                id: "p-radio-2",
                                                                                label: "ปิดใช้งาน",
                                                                                checked: status == 2 ? true : false,
                                                                                className: "form-check-st-2 tc-7 mt-0",
                                                                                onChange: function() {
                                                                                    setStatus(2);
                                                                                }
                                                                            })
                                                                        ]
                                                                    }, "p-radio")
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "col-xl-2 col-md-12",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                        className: "mb-2 mt-2 tc-10",
                                                                        children: "รูปภาพหน้าร้าน"
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("div", {
                                                                        className: "align-items-center mb-2 border-dashed-1 text-center w-[200px] h-[200px]",
                                                                        onClick: function(e) {
                                                                            return document.getElementById("fileProductUpload").click();
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("input", {
                                                                                type: "file",
                                                                                name: "",
                                                                                className: "fileUpload hide-input",
                                                                                id: "fileProductUpload",
                                                                                accept: ".png, .jpg",
                                                                                onChange: function(e) {
                                                                                    handlePreviewimage(e);
                                                                                }
                                                                            }),
                                                                            imgPath ? /*#__PURE__*/ _jsx("img", {
                                                                                src: imgPath,
                                                                                style: {
                                                                                    width: "170px",
                                                                                    height: "170px"
                                                                                }
                                                                            }) : /*#__PURE__*/ _jsxs("center", {
                                                                                className: "py-5",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(AddPhotoAlternateIcon, {
                                                                                        style: {
                                                                                            fontSize: 50,
                                                                                            color: "#B00412"
                                                                                        }
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx("div", {
                                                                                        className: "fs-12",
                                                                                        style: {
                                                                                            color: "#B00412"
                                                                                        },
                                                                                        children: "เพิ่มรูปภาพ"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-3 col-md-12",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1 mt-5",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "ผู้ดูแล"
                                                                        }),
                                                                        adminInfo.userRoleId != 3 ? /*#__PURE__*/ _jsx(Select, {
                                                                            as: "select",
                                                                            name: "sh_branch_intendant",
                                                                            options: opIntendant,
                                                                            placeholder: "เลือกผู้ดูแล",
                                                                            value: opIntendant.filter(function(item) {
                                                                                return item.value === values.sh_branch_intendant;
                                                                            }),
                                                                            onChange: function(e) {
                                                                                setValues(_object_spread_props(_object_spread({}, values), {
                                                                                    sh_branch_intendant: e.value
                                                                                }));
                                                                            },
                                                                            className: !!errors.sh_branch_intendant ? "w-100 select-st-1 isInvalid " : "w-100 select-st-1",
                                                                            isInvalid: !!errors.sh_branch_intendant
                                                                        }) : /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "sh_branch_intendant",
                                                                            className: "form-control",
                                                                            placeholder: "ผู้ดูแล",
                                                                            value: (adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userFullName) || "",
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: !isMobile ? "card pagezoom card-st-3 mb-1" : "card card-st-3 mb-1",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "card-body px-xl-3",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "tc-8 py-2 fs-18 fw-bold px-3",
                                                    children: "ข้อมูลจัดส่ง"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "pt-3 px-3",
                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-6 col-md-12",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "ชื่อผู้รับ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "sh_branch_recipient_name",
                                                                            placeholder: "กรอกชื่อผู้รับ",
                                                                            value: values.sh_branch_recipient_name || "",
                                                                            onChange: function(e) {
                                                                                setFieldValue("sh_branch_recipient_name", e.target.value);
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-6 col-md-12",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "เบอร์ผู้รับ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "sh_branch_recipient_phone",
                                                                            placeholder: "กรอกเบอร์ผู้รับ",
                                                                            value: values.sh_branch_recipient_phone || "",
                                                                            onChange: function(e) {
                                                                                setFieldValue("sh_branch_recipient_phone", e.target.value);
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-12 col-md-12",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "ที่อยู่จัดส่ง"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            as: "textarea",
                                                                            rows: 3,
                                                                            name: "sh_branch_address",
                                                                            className: "form-control",
                                                                            placeholder: "กรอกที่อยู่จัดส่ง",
                                                                            value: values.sh_branch_address || "",
                                                                            onChange: function(e) {
                                                                                setFieldValue("sh_branch_address", e.target.value);
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-6 col-md-12",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "บริษัทขนส่ง"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Select, _object_spread_props(_object_spread({
                                                                            name: "sh_branch_shippingid",
                                                                            options: shippingOptions,
                                                                            placeholder: "เลือกบริษัทขนส่ง",
                                                                            isClearable: true
                                                                        }, shippingSelectMenuProps), {
                                                                            value: shippingOptions.find(function(item) {
                                                                                return item.value === Number(values.sh_branch_shippingid);
                                                                            }) || null,
                                                                            onChange: function(option) {
                                                                                setFieldValue("sh_branch_shippingid", (option === null || option === void 0 ? void 0 : option.value) || null);
                                                                            },
                                                                            className: "w-100 select-st-1"
                                                                        }))
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "col-xl-6 col-md-12",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                        className: "mb-2 tc-10",
                                                                        children: "วิธีจ่ายเงินค่าขนส่ง"
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Check, {
                                                                                inline: true,
                                                                                type: "radio",
                                                                                id: "shipping-paytype-origin",
                                                                                name: "sh_branch_shipping_paytype",
                                                                                label: "เก็บต้นทาง",
                                                                                checked: Number(values.sh_branch_shipping_paytype || 1) === 1,
                                                                                className: "form-check-st-2 tc-7 mt-0",
                                                                                onChange: function() {
                                                                                    setFieldValue("sh_branch_shipping_paytype", 1);
                                                                                }
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Check, {
                                                                                inline: true,
                                                                                type: "radio",
                                                                                id: "shipping-paytype-destination",
                                                                                name: "sh_branch_shipping_paytype",
                                                                                label: "เก็บปลายทาง",
                                                                                checked: Number(values.sh_branch_shipping_paytype || 1) === 2,
                                                                                className: "form-check-st-2 tc-7 mt-0",
                                                                                onChange: function() {
                                                                                    setFieldValue("sh_branch_shipping_paytype", 2);
                                                                                }
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: !isMobile ? "card pagezoom card-st-3 mb-4" : "card card-st-3 mb-4",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "card-body px-xl-3 d-flex ",
                                    children: [
                                        /*#__PURE__*/ _jsx(Button, {
                                            type: "button",
                                            onClick: function(e) {
                                                navigate(shopId ? "/shop/manage/".concat(shopId) : "/shop");
                                            },
                                            className: "btn-st-6 me-3 btn ms-auto",
                                            children: "ยกเลิก"
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            type: "button",
                                            onClick: /*#__PURE__*/ _async_to_generator(function() {
                                                var validationErrors, errorFields;
                                                return _ts_generator(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            return [
                                                                4,
                                                                validateForm()
                                                            ];
                                                        case 1:
                                                            validationErrors = _state.sent();
                                                            errorFields = Object.keys(validationErrors);
                                                            if (errorFields.length > 0) {
                                                                setTouched(Object.fromEntries(errorFields.map(function(field) {
                                                                    return [
                                                                        field,
                                                                        true
                                                                    ];
                                                                })), false);
                                                                window.requestAnimationFrame(function() {
                                                                    var invalidField = errorFields.map(function(field) {
                                                                        return document.querySelector('[name="'.concat(field, '"]'));
                                                                    }).find(Boolean);
                                                                    if (invalidField) {
                                                                        invalidField.scrollIntoView({
                                                                            behavior: "smooth",
                                                                            block: "center"
                                                                        });
                                                                        invalidField.focus({
                                                                            preventScroll: true
                                                                        });
                                                                    }
                                                                });
                                                                return [
                                                                    2
                                                                ];
                                                            }
                                                            handleSubmit();
                                                            return [
                                                                2
                                                            ];
                                                    }
                                                });
                                            }),
                                            className: "btn-st-3 me-3",
                                            children: "บันทึก"
                                        })
                                    ]
                                })
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ _jsx(SuccessModal, {
                show: modalsuccess,
                onHide: function() {
                    return setModalsuccess(false);
                },
                textsuccess: textsuccess,
                navigate: navigate,
                direction: shopId && "/shop/manage/".concat(shopId) || !shopId && "/shop"
            })
        ]
    });
}
export function StatusModal(param) {
    var modal = param.modal, setModal = param.setModal, setTextsuccess = param.setTextsuccess, setModalsuccess = param.setModalsuccess, setIsLoading = param.setIsLoading, setModalObj = param.setModalObj, modalObj = param.modalObj, dataID = param.dataID, shopId = param.shopId, isMobile = param.isMobile;
    var _modal_data;
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(1), 2), type = _useState[0], setType = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), id = _useState1[0], setId = _useState1[1];
    var updateStatusShopReducer = useAppSelector(function(state) {
        return state.updateStatusShopReducer;
    });
    var updateStatusShBranchReducer = useAppSelector(function(state) {
        return state.updateStatusShBranchReducer;
    });
    var updateShBranchReducer = useAppSelector(function(state) {
        return state.updateShBranchReducer;
    });
    useEffect(function() {
        if (modal.data == null) {
            setType(1);
            setId(0);
        }
        if (modal.data != null) {
            var vul = modal.data;
            setType(vul.status);
            setId(vul.id);
        }
    }, [
        modal.data,
        modal.open
    ]);
    useEffect(function() {
        setIsLoading(updateStatusShopReducer.isFetching || updateStatusShBranchReducer.isFetching || updateShBranchReducer.isFetching);
        if (updateStatusShopReducer.data && !updateStatusShopReducer.isError) {
            setTextsuccess("แก้ไขสถานะร้านค้าสำเร็จ");
            setModalsuccess(true);
            dispatch(clearupdateStatusShop());
            dispatch(getDataShop(null, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setType(1);
            setId(0);
        }
        if (updateStatusShBranchReducer.data && !updateStatusShBranchReducer.isError) {
            setTextsuccess("แก้ไขสถานะสาขาร้านค้าสำเร็จ");
            setModalsuccess(true);
            dispatch(clearupdateStatusShBranch());
            var data = {
                shopid: parseInt(shopId),
                status: null
            };
            dispatch(getDataShopBranch(data, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setType(1);
            setId(0);
        }
        if (updateShBranchReducer.data && !updateShBranchReducer.isError) {
            setTextsuccess("แก้ไขระงับวงเงินเครดิตสำเร็จ");
            setModalsuccess(true);
            dispatch(clearupdateShBranch());
            var data1 = {
                shopid: parseInt(shopId),
                status: null
            };
            dispatch(getDataShopBranch(data1, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setType(1);
            setId(0);
        }
    }, [
        updateStatusShopReducer,
        updateStatusShBranchReducer,
        updateShBranchReducer
    ]);
    var onClickModel = function() {
        if (modal.typeData == "shShopStatus") {
            var data = {
                shshopid: id,
                shshopstatus: type == 1 ? 2 : 1
            };
            dispatch(updateStatusShop(data, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        } else if (modal.typeData == "shBranchStatus") {
            var data1 = {
                branchid: id,
                branchstatus: type == 1 ? 2 : 1
            };
            dispatch(updateStatusShBranch(data1, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        } else if (modal.typeData == "shBranchCreditStatus") {
            var data2 = {
                sh_branch_id: id,
                sh_branch_creditstatus: type == 1 ? 2 : 1
            };
            dispatch(updateShBranch(data2, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "px-3",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: !isMobile ? "text-center fs-24 tc-5 my-4" : "text-center fs-20 tc-5 my-4",
                    children: "คุณต้องการเปลี่ยนสถานะการใช้งานข้อมูลนี้"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: !isMobile ? "text-center fs-24 my-6" : "text-center fs-20 my-3",
                    children: (_modal_data = modal.data) === null || _modal_data === void 0 ? void 0 : _modal_data.name
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: !isMobile ? "text-center mt-5" : "text-center mt-3",
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-6 me-3",
                            onClick: function() {
                                return setModal(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            children: "ยกเลิก"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-dg",
                            onClick: function(e) {
                                onClickModel();
                            },
                            children: "ยืนยัน"
                        })
                    ]
                })
            ]
        })
    });
}
export function DelModel(param) {
    var modal = param.modal, setModal = param.setModal, setTextsuccess = param.setTextsuccess, setModalsuccess = param.setModalsuccess, setIsLoading = param.setIsLoading, setModalObj = param.setModalObj, modalObj = param.modalObj, dataID = param.dataID, shopId = param.shopId, isMobile = param.isMobile;
    var _modal_data;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(0), 2), id = _useState[0], setId = _useState[1];
    var deleteShopReducer = useAppSelector(function(state) {
        return state.deleteShopReducer;
    });
    var deleteShBranchReducer = useAppSelector(function(state) {
        return state.deleteShBranchReducer;
    });
    useEffect(function() {
        setIsLoading(deleteShopReducer.isFetching || deleteShBranchReducer.isFetching);
        if (deleteShopReducer.data && !deleteShopReducer.isError) {
            setTextsuccess("ลบร้านค้าสำเร็จ");
            setModalsuccess(true);
            dispatch(cleardeleteShop());
            dispatch(getDataShop(null, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
        }
        if (deleteShBranchReducer.data && !deleteShBranchReducer.isError) {
            setTextsuccess("ลบสาขาร้านค้าสำเร็จ");
            setModalsuccess(true);
            dispatch(cleardeleteShBranch());
            var data = {
                shopid: parseInt(shopId),
                status: null
            };
            dispatch(getDataShopBranch(data, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
        }
    }, [
        deleteShBranchReducer,
        deleteShopReducer
    ]);
    useEffect(function() {
        if (modal.data != null) {
            var vul = modal.data;
            setId(vul.id);
        }
    }, [
        modal.data,
        modal.open
    ]);
    var onClickModel = function() {
        if (modal.typeData == "shShopDel") {
            var data = {
                shshopid: parseInt(id)
            };
            dispatch(deleteShop(data, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        } else if (modal.typeData == "shBranchDel") {
            console.log("shBranchDel");
            var data1 = {
                branchid: parseInt(id)
            };
            dispatch(deleteShBranch(data1, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "px-3",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: !isMobile ? "text-center fs-24 tc-5 my-4" : "text-center fs-20 tc-5 my-2",
                    children: "คุณต้องการลบข้อมูลนี้"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: !isMobile ? "text-center fs-24 my-6" : "text-center fs-20 my-3",
                    children: (_modal_data = modal.data) === null || _modal_data === void 0 ? void 0 : _modal_data.name
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: !isMobile ? "text-center mt-5" : "text-center mt-3",
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-6 me-3",
                            onClick: function() {
                                return setModal(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            children: "ยกเลิก"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-dg",
                            onClick: function(e) {
                                onClickModel();
                            },
                            children: "ยืนยัน"
                        })
                    ]
                })
            ]
        })
    });
}
function SuccessModal(_param) {
    var navigate = _param.navigate, show = _param.show, direction = _param.direction, props = _object_without_properties(_param, [
        "navigate",
        "show",
        "direction"
    ]);
    var handleCloseAndNavigate = function() {
        props.onHide();
        if (direction) {
            navigate(direction);
        }
    };
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, props), {
        size: "sm",
        centered: true,
        show: show,
        onHide: handleCloseAndNavigate,
        children: /*#__PURE__*/ _jsx(Modal.Body, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: "px-3 py-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4",
                        children: /*#__PURE__*/ _jsxs("svg", {
                            width: "84",
                            height: "83",
                            viewBox: "0 0 84 83",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "mx-auto",
                            children: [
                                /*#__PURE__*/ _jsx("circle", {
                                    cx: "42",
                                    cy: "41.5",
                                    r: "41.5",
                                    fill: "#2DC76D"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M56.0123 30.9902L36.7444 50.2581L27.9863 41.5",
                                    stroke: "white",
                                    strokeWidth: "5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fs-18 tc-7",
                        children: props.textsuccess
                    })
                ]
            })
        })
    }));
}
